// src/pages/subscription/Cancel.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './subscription.css'

const SubscriptionCancel: React.FC = () => {
  const nav = useNavigate();
  useEffect(() => {
    // キャンセル画面を短く表示して戻す
    const timeout = setTimeout(() => nav('/account/subscription'), 2000);
    return () => clearTimeout(timeout);
  }, [nav]);

  return (
    <div className="stripe-back" style={{ padding: 20, textAlign: 'center' }}>
      <h1>サブスクリプションの手続きがキャンセルされました</h1>
      <p>サブスクリプション管理画面に戻ります...</p>
    </div>
  );
};

export default SubscriptionCancel;
